import { getEnvVariables } from "../../env";

const env = getEnvVariables();

const modelEnv = {
  apiUrl: `${env.API_V3_URL}v3/models`,
};

export default modelEnv;
